import React from 'react';
import { HeartIcon, MapPinIcon } from 'lucide-react';
import { Stars } from '../Stars';
import { moreTestimonials } from '../../data/landing';
export function MoreTestimonials() {
  return <section className="bg-brand-soft px-5 py-16 md:py-24" data-id="element-163" data-mp="2bnncre4rtu1g">
      <div className="mx-auto max-w-6xl" data-id="element-164" data-mp="2bq9ir9c0k1hk">
        <h2 className="flex items-center justify-center gap-3 text-center text-3xl font-black uppercase tracking-tight text-brand md:text-5xl" data-id="element-165" data-mp="26plmo98xgugh">
          <HeartIcon className="h-8 w-8 shrink-0 fill-danger text-danger" aria-hidden="true" data-id="element-166" data-mp="22otb39cl2dh1" />
          Más personas que ya lo tienen
        </h2>
        <div className="mt-12 grid gap-5 sm:grid-cols-2" data-id="element-167" data-mp="1sx5mrhbbpcjs">
          {moreTestimonials.map(t => <figure key={t.author} className="flex flex-col rounded-3xl bg-white p-7 shadow-sm" data-id="element-168" data-mp="1nz43av9zjb7s">
              <div className="flex items-center gap-4" data-id="element-169" data-mp="1j00x37i9qyy8">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand text-base font-black text-white" data-id="element-170" data-mp="1j1lst0gbknxo">
                  {t.initials}
                </span>
                <div data-id="element-171" data-mp="3v7zv3n8yj3h2">
                  <p className="font-extrabold text-brand" data-id="element-172" data-mp="3un4e1gfm3c0">{t.author}</p>
                  <p className="flex flex-wrap items-center gap-x-2 text-sm text-muted" data-id="element-173" data-mp="3vya46tftl5r">
                    <span className="flex items-center gap-1" data-id="element-174" data-mp="3lcpt2zik6w3a">
                      <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-175" data-mp="3q9gc9vpnu7sx" /> {t.city}
                    </span>
                    <span aria-hidden="true" data-id="element-176" data-mp="hvfzooek52g6">·</span>
                    {t.tag}
                  </p>
                </div>
              </div>
              <div className="mt-5" data-id="element-177" data-mp="mr569bozvjlz">
                <Stars data-id="element-178" data-mp="8uhwg8by0yyn" />
              </div>
              <blockquote className="mt-3 text-lg leading-relaxed text-charcoal" data-id="element-179" data-mp="8tgls4yuaehg">“{t.quote}”</blockquote>
            </figure>)}
        </div>
      </div>
    </section>;
}